module.exports = __webpack_public_path__ + "static/media/september_1.8786e7ee.png";